<template>
  <div class="over-visible">
    <div id="data-list-list-view" class="data-list-container over-visible">


    <vs-table
      ref="table"
      class="hide-table table-with-dropdowns"
      :sst="true"
      @sort="handleSort"
      :data="containersData">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <!-- ADD NEW -->
          <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewContainer">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 float-left text-base text-primary">Nueva Firma Masiva</span>
          </div>
        </div>
      </div>

      <div slot="header" class="flex flex-wrap-reverse items-center">
        <vs-chip>
          {{ getInitialItem + 1 }}-{{ getInitialItem + containersData.length }} de {{ getTotalItems }}
        </vs-chip>
      </div>

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between d-b-search">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container ml-auto">
            <vs-input icon-pack="feather" icon="icon-search" placeholder="Nombre de firma masiva" icon-no-border v-model="searchQuery" @input="handleSearch" class="is-label-placeholder border-r-50 min-w-search" />
        </div>
      </div>

      <template slot="thead">
        <vs-th sort-key="status">Estado</vs-th>
        <vs-th sort-key="name">Nombre</vs-th>
        <vs-th sort-key="createdAt">Fecha de creación</vs-th>
        <vs-th>Acciones</vs-th>
      </template>

      <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" @click.native="openContainerDetails(tr)">

            <vs-td :data="data[indextr].status" class="cursor-pointer">
               <vs-chip :color="getStatusColor(data[indextr].status)">
                {{ getStatusLabel(data[indextr].status) }}
              </vs-chip>
            </vs-td>

            <vs-td :data="data[indextr].name" class="cursor-pointer">
              <p class="product-name font-medium truncate">{{ data[indextr].name }}</p>
            </vs-td>

            <vs-td :data="data[indextr].created_at" class="cursor-pointer">
              <span>{{ formatDate(data[indextr].created_at) }}</span>
            </vs-td>

            <vs-td class="whitespace-no-wrap" @click.native.stop>
              <!-- Ver Detalles -->
              <vx-tooltip text="Ver detalles" position="top" class="d-inline-block mr-2">
                <feather-icon icon="SlidersIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="openContainerDetails(data[indextr])" />
              </vx-tooltip>

              <!-- Editar -->
              <vx-tooltip text="Editar" position="top" class="d-inline-block mr-2">
                <feather-icon icon="Edit2Icon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editContainer(data[indextr])" />
              </vx-tooltip>

              <!-- Cerrar Firma Masiva -->
              <vx-tooltip v-if="data[indextr].status === 'ON_HOLD'" text="Cerrar firma masiva" position="top" class="d-inline-block mr-2">
                <feather-icon icon="LockIcon" svgClasses="w-5 h-5 hover:text-warning stroke-current" @click.stop="closeContainer(data[indextr])" />
              </vx-tooltip>

              <!-- Eliminar -->
              <vx-tooltip text="Eliminar" position="top" class="d-inline-block">
                <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" @click.stop="deleteContainer(data[indextr])" />
              </vx-tooltip>
            </vs-td>

          </vs-tr>
      </template>
    </vs-table>

    <vs-table
      class="show-table hidden"
      :sst="true"
      @sort="handleSort"
      :data="containersData">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <!-- ADD NEW -->
          <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewContainer">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 float-left text-base text-primary">Nueva Firma Masiva</span>
          </div>
        </div>
      </div>

      <div slot="header" class="flex flex-wrap-reverse items-center">
        <vs-chip>
          {{ getInitialItem + 1 }}-{{ getInitialItem + containersData.length }} de {{ getTotalItems }}
        </vs-chip>
      </div>

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between d-b-search">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container ml-auto">
            <vs-input icon-pack="feather" icon="icon-search" placeholder="Nombre de firma masiva" icon-no-border v-model="searchQuery" @input="handleSearch" class="is-label-placeholder border-r-50 min-w-search" />
        </div>
      </div>

      <template slot="thead">
        <vs-th>LISTADO DE FIRMA MASIVA</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td class="py-3 px-0">
            <table>
              <tbody class="no-shadow">
                <tr class="cursor-pointer" @click="openContainerDetails(tr)">
                  <td class="font-w-600">Estado</td>
                  <td :data="data[indextr].status">
                     <vs-chip :color="getStatusColor(data[indextr].status)">
                      {{ getStatusLabel(data[indextr].status) }}
                    </vs-chip>
                  </td>
                </tr>
                <tr class="cursor-pointer" @click="openContainerDetails(tr)">
                  <td class="font-w-600">Nombre</td>
                  <td :data="data[indextr].name">
                    <p class="product-name font-medium truncate">{{ data[indextr].name }}</p>
                  </td>
                </tr>
                <tr class="cursor-pointer" @click="openContainerDetails(tr)">
                  <td class="font-w-600">Fecha de creación</td>
                  <td :data="data[indextr].created_at">
                    <span>{{ formatDate(data[indextr].created_at) }}</span>
                  </td>
                </tr>
                <tr>
                  <td class="font-w-600">Acciones</td>
                  <td class="whitespace-no-wrap">
                    <!-- Ver Detalles -->
                    <vx-tooltip text="Ver detalles" position="top" class="d-inline-block mr-2">
                      <feather-icon icon="SlidersIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="openContainerDetails(data[indextr])" />
                    </vx-tooltip>

                    <!-- Editar -->
                    <vx-tooltip text="Editar" position="top" class="d-inline-block mr-2">
                      <feather-icon icon="Edit2Icon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editContainer(data[indextr])" />
                    </vx-tooltip>

                    <!-- Cerrar Firma Masiva -->
                    <vx-tooltip v-if="data[indextr].status === 'ON_HOLD'" text="Cerrar firma masiva" position="top" class="d-inline-block mr-2">
                      <feather-icon icon="LockIcon" svgClasses="w-5 h-5 hover:text-warning stroke-current" @click.stop="closeContainer(data[indextr])" />
                    </vx-tooltip>

                    <!-- Eliminar -->
                    <vx-tooltip text="Eliminar" position="top" class="d-inline-block">
                      <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" @click.stop="deleteContainer(data[indextr])" />
                    </vx-tooltip>
                  </td>
                </tr>
              </tbody>
            </table>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <div class="mt-8">
      <vs-pagination :total="totalPages" v-model="currentPage" :max="5" @input="handleChangePage"></vs-pagination>
    </div>

    <!-- Upload Modal Component -->
    <upload-container-documents 
      :active="uploadPopupActive" 
      :container="activeContainer" 
      @close="uploadPopupActive = false"
      @upload-success="handleUploadSuccess('massive')"
    />

    <!-- Upload Single Document Component -->
    <upload-single-document
      :active="uploadSinglePopupActive"
      :container="activeContainer"
      @close="uploadSinglePopupActive = false"
      @upload-success="handleUploadSuccess('single')"
    />

    <!-- Create Container Component -->
    <create-container
      :active="createPopupActive"
      @close="createPopupActive = false"
      @create-success="handleCreateSuccess"
    />

    <!-- Edit Container Component -->
    <edit-container
      :active="editPopupActive"
      :container="activeContainer"
      @close="editPopupActive = false"
      @edit-success="handleEditSuccess"
      @open-upload-single="openUploadSingle"
      @open-upload-massive="openUploadMassive"
    />

    <!-- Details Modal -->
    <container-details-modal
      ref="containerDetailsModal"
      :active="detailPopupActive"
      :container-uuid="activeContainer ? activeContainer.uuid : ''"
      @close="detailPopupActive = false"
      @open-upload-single="openUploadSingle"
      @open-upload-massive="openUploadMassive"
    />


    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions } from "vuex";  
import UploadContainerDocuments from '../components/UploadContainerDocuments.vue';
import UploadSingleDocument from '../components/UploadSingleDocument.vue';
import CreateContainer from '../components/CreateContainer.vue';
import EditContainer from '../components/EditContainer.vue';
import ContainerDetailsModal from '../components/ContainerDetailsModal.vue';

export default {
  name: "AllContainersList",
  components: {
    UploadContainerDocuments,
    UploadSingleDocument,
    CreateContainer,
    EditContainer,
    ContainerDetailsModal
  },
  data() {
    return {
      itemsPerPage: 10,
      // Filter Data
      status: '',
      startDate: '',
      endDate: '',
      searchQuery: '',
      statusOptions: [
        { label: 'Todos', value: '' },
        { label: 'En espera', value: 'ON_HOLD' },
        { label: 'Cerrado', value: 'CLOSED' },
        { label: 'Firmando', value: 'SIGNING' },
        { label: 'Firmado', value: 'SIGNED' },
        { label: 'Parcialmente firmado', value: 'PARTIAL_SIGNED' },
        { label: 'Rechazado', value: 'REJECTED' },
        { label: 'Error', value: 'ERROR' }
      ],
      detailPopupActive: false,
      uploadPopupActive: false,
      uploadSinglePopupActive: false,
      createPopupActive: false,
      editPopupActive: false,
      activeContainer: null,
      
      currentPage: 1,
      sort: {
        key: 'createdAt',
        active: 'desc'
      },
      timer: null
    }
  },
  computed: {
    containersData() {
      return this.$store.state.containerManagement.containers.data
    },
    totalPages() {
      return this.$store.state.containerManagement.containers.pagination.total
    },
    getInitialItem() {
      return this.$store.state.containerManagement.containers.pagination.initialItem
    },
    getTotalItems() {
      return this.$store.state.containerManagement.containers.pagination.totalItems
    }
  },
  mounted() {
    this.fetchContainers().then(() => {
      const autoOpen = this.$route.query.autoOpen
      const uuid = this.$route.query.uuid

      if (autoOpen && this.containersData.length > 0) {
        // Al estar ordenados por fecha descendente, el primero es el más reciente
        this.openContainerDetails(this.containersData[0])
      } else if (uuid) {
        const container = this.containersData.find(c => c.uuid === uuid || c.id === uuid)
        if (container) {
          this.openContainerDetails(container)
        }
      }

      // Limpiar los parámetros de la URL para que no se vuelva a abrir al recargar
      if (autoOpen || uuid) {
        this.$router.replace({ query: {} })
      }
    })
  },
  methods: {
    ...mapActions({
      fetchContainersAction: "containerManagement/getAll"
    }),
    fetchContainers(showLoading = false) {
      if (showLoading) this.$vs.loading()
      
      const sortValue = this.sort.active === 'desc' ? `${this.sort.key},DESC` : `${this.sort.key},ASC`
      
      return this.fetchContainersAction({
        page: this.currentPage - 1,
        sort: sortValue,
        search: this.searchQuery,
        status: this.status,
        start_date: this.startDate,
        end_date: this.endDate
      })
      .then(() => {
        if (showLoading) this.$vs.loading.close()
      })
      .catch(error => {
        const message = (error && error.toString()) || 'Error al cargar las firmas masivas';
        this.$store.dispatch('alert/error', message.replace(/ON_HOLD/g, 'En espera'))
        if (showLoading) this.$vs.loading.close()
      })
    },
    handleChangePage(page) {
      this.currentPage = page
      this.fetchContainers()
    },
    handleSort(key, active) {
      this.sort.key = key
      this.sort.active = active
      this.fetchContainers()
    },
    handleSearch(searching) {
      this.searchQuery = searching
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.fetchContainers(false)
      }, 1000)
    },
    formatDate(date) {
      return moment(date).format('DD/MM/YYYY, h:mm:ss a')
    },
    getStatusColor(status) {
      if (status === 'SIGNED') return 'success'
      if (status === 'ON_HOLD') return 'warning'
      if (status === 'REJECTED') return 'danger'
      if (status === 'PARTIAL_SIGNED') return 'primary'
      if (status === 'SIGNING') return 'primary'
      if (status === 'CLOSED') return 'dark'
      if (status === 'ERROR') return 'danger'
      return 'primary'
    },
    getStatusLabel(status) {
      const option = this.statusOptions.find(opt => opt.value === status)
      return option ? option.label : status
    },
    addNewContainer() {
      this.$router.push('/bulk-signature/create')
    },
    handleCreateSuccess() {
      this.fetchContainers()
      this.$store.dispatch('alert/success', 'Firma masiva creada correctamente.')
    },
    uploadDocuments(container) {
      this.activeContainer = container
      this.uploadPopupActive = true
    },
    openUploadMassive() {
        this.uploadPopupActive = true
    },
    openUploadSingle() {
        this.uploadSinglePopupActive = true
    },
    downloadZip(container) {
      this.$store.dispatch('alert/success', `Iniciando descarga de: ${container.name}.zip`)
    },
    handleUploadSuccess(type) {
      // Refresh list or update local data if needed
      this.$store.dispatch('alert/success', `Documentos subidos a ${this.activeContainer ? this.activeContainer.name : ''} correctamente.`)
      
      // If the details modal is active, refresh its data
      if (this.detailPopupActive && this.$refs.containerDetailsModal) {
        if (type === 'massive') {
          // Cambiar a la pestaña de Carga Masiva (índice 2)
          this.$refs.containerDetailsModal.activeTab = 2;
          this.$refs.containerDetailsModal.fetchActivity();
        } else {
          this.$refs.containerDetailsModal.fetchDocuments();
        }
      }
    },
    signDocuments(container) {
      this.$store.dispatch('alert/success', `Iniciando firma para: ${container.name}`)
    },
    editContainer(container) {
      this.activeContainer = container
      this.editPopupActive = true
    },
    openContainerDetails(container) {
       this.activeContainer = container
       this.detailPopupActive = true
    },
    deleteContainer(container) {
      if (container.status !== 'ON_HOLD') {
        this.$vs.notify({
          title: 'Acción no permitida',
          text: 'Para eliminar una firma masiva esta debe estar en status "En espera". Una vez que el proceso ha avanzado, ya no es posible eliminarla.',
          color: 'warning',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center'
        });
        return;
      }

      let instance = this;
      this.$vs.dialog({
        type:'confirm',
        color: 'danger',
        title: '¿Estás seguro?',
        text: `¿Estás seguro de eliminar la firma masiva "${container.name}"? Esta acción no se puede deshacer.`,
        acceptText: "Sí, eliminar",
        cancelText: "Cancelar",
        accept: function () {
          instance.$store.dispatch("containerManagement/deleteContainer", {container: container, aclChangeRole: this.$acl.change})
            .then(
              () => {
                instance.fetchContainers();
                instance.$store.dispatch('alert/success', 'Firma masiva eliminada correctamente.')
              }
            )
            .catch(error => {
               const message = (error && error.toString()) || 'Error al eliminar la firma masiva';
               instance.$store.dispatch('alert/error', message.replace(/ON_HOLD/g, 'En espera'))
            })
        }
      });
    },
    handleEditSuccess() {
      this.fetchContainers()
      this.$store.dispatch('alert/success', 'Firma masiva actualizada correctamente.')
    },
    closeContainer(container) {
      let instance = this;
      
      this.$vs.loading();
      
      // Verificar si hay procesos de carga masiva pendientes
      this.$store.dispatch('containerManagement/getUploadProcesses', container.uuid)
        .then(response => {
          this.$vs.loading.close();
          const activity = response.data || [];
          const pendingProcesses = activity.filter(process => 
            process.status === 'QUEUED' || process.status === 'PROCESSING'
          );

          if (pendingProcesses.length > 0) {
            this.$vs.notify({
              title: 'Cierre no permitido',
              text: 'Aún hay cargas masivas en proceso. Por favor, espera a que terminen para cerrar la firma masiva.',
              color: 'warning',
              iconPack: 'feather',
              icon: 'icon-alert-triangle',
              position: 'top-center'
            });
            
            // Abrir el detalle en la pestaña de Carga Masiva para que vea el progreso
            this.openContainerDetails(container);
            setTimeout(() => {
              if (this.$refs.containerDetailsModal) {
                this.$refs.containerDetailsModal.activeTab = 2;
              }
            }, 300);
            return;
          }

          // Nueva validación: Verificar si tiene documentos antes de cerrar
          this.$vs.loading({ text: 'Validando documentos...' });
          this.$store.dispatch('containerManagement/getDocuments', { uuid: container.uuid })
            .then(docResponse => {
              this.$vs.loading.close();
              const documents = docResponse.data || [];
              
              if (documents.length === 0) {
                this.$vs.notify({
                  title: 'Cierre no permitido',
                  text: 'No puedes cerrar la firma masiva porque no tiene documentos.',
                  color: 'danger',
                  iconPack: 'feather',
                  icon: 'icon-alert-circle',
                  position: 'top-center'
                });
                return;
              }

              // Si tiene documentos y no hay cargas pendientes, procedemos con la confirmación normal
              this.$vs.dialog({
                type: 'confirm',
                color: 'warning',
                title: 'Cerrar Firma Masiva',
                text: `Al cerrar la firma masiva "${container.name}", ya no se podrán recibir más documentos y comenzará el proceso de firmado.`,
                acceptText: 'Sí, cerrar',
                cancelText: 'Cancelar',
                accept: () => {
                  this.$vs.loading();
                  instance.$store.dispatch('containerManagement/updateContainer', {
                    uuid: container.id,
                    data: { status: 'CLOSED' }
                  })
                  .then(() => {
                    this.$vs.loading.close();
                    instance.fetchContainers();
                    instance.$store.dispatch('alert/success', 'La firma masiva ha sido cerrado correctamente.');
                  })
                  .catch(error => {
                    this.$vs.loading.close();
                    const message = (error && error.toString()) || 'Error al cerrar la firma masiva';
                    instance.$store.dispatch('alert/error', message.replace(/ON_HOLD/g, 'En espera'));
                  });
                }
              });
            })
            .catch(() => {
              this.$vs.loading.close();
              this.$vs.notify({
                title: 'Error de validación',
                text: 'Hubo un problema al verificar los documentos de la firma masiva.',
                color: 'danger',
                position: 'top-center'
              });
            });
        })
        .catch(() => {
          this.$vs.loading.close();
          // Si falla la verificación de procesos, por seguridad permitimos el flujo normal o mostramos error
          this.$vs.notify({
            title: 'Error de verificación',
            text: 'No pudimos verificar el estado de las cargas masivas. Inténtalo de nuevo.',
            color: 'danger',
            position: 'top-center'
          });
        });
    },
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/custom/documentListResponsive.scss";

#data-list-list-view {
  .vs-con-table {
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }
          &:last-child {
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }

    table {
      border-collapse: collapse;
    }
  }
}
.cursor-pointer {
  cursor: pointer !important;
}
</style>